// Build-time injected config. `__VID_*__` tokens are replaced by esbuild `define`.
// At runtime these are plain string literals — no process.env in the browser.

declare const __VID_API_BASE__: string;
declare const __VID_RP_ID__: string;
declare const __VID_RP_NAME__: string;
declare const __VID_USE_MOCK__: string;
declare const __VID_APP_VERSION__: string;

export const config = {
  apiBase: __VID_API_BASE__,
  rpId: __VID_RP_ID__,
  rpName: __VID_RP_NAME__,
  useMock: __VID_USE_MOCK__ === 'true',
  appVersion: __VID_APP_VERSION__,
};

export type Config = typeof config;
